import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { RadioInput } from '@synoptic/ui-kit/radio-input/radio-input.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { clsx } from 'clsx';
import { FC, useRef } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useSetUsername } from '@/components/set-username/use-set-username.ts';
import {
  formFieldsContainer,
  submitAuthFormButton,
  subButton,
} from '../../_auth/page.css.ts';
import { useGenerateUsernames } from './use-generate-usernames.ts';

type FormInputs = {
  username: string | undefined | null;
};

export const ChooseUsernameForm: FC<{
  onChooseUsername: (username: string) => void;
  possibleUsernames: string[] | null | undefined;
}> = ({ onChooseUsername, possibleUsernames }) => {
  const [generateUsernames, result] = useGenerateUsernames();
  const [setUsername] = useSetUsername();

  const { handleSubmit, formState, reset, register } = useForm<FormInputs>({
    values: { username: possibleUsernames && possibleUsernames[0] },
  });
  const formRef = useRef<HTMLFormElement>(null);
  const toast = useToast();

  const submit: SubmitHandler<FormInputs> = async (data) => {
    const { username } = data;

    try {
      await setUsername(username as string);

      onChooseUsername(username as string);
      reset();
    } catch (e) {
      toast.error({ title: String(e) });
    }
  };

  const regenerateUsernames = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    try {
      e.preventDefault();
      await generateUsernames();
    } catch (e) {
      toast.error({ title: String(e) });
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit(submit)}>
      <div className={formFieldsContainer}>
        {possibleUsernames
          ? possibleUsernames.map((item, index) => (
              <RadioInput
                key={index}
                {...register('username')}
                type="radio"
                value={item}
                id={item}
                data-testid={'radio-input'}
              >
                {item}
              </RadioInput>
            ))
          : null}
        <Button
          className={clsx(submitAuthFormButton, subButton)}
          size={'small'}
          onClick={regenerateUsernames}
          disabled={formState.isSubmitting || result.loading}
          loading={result.loading}
          variant="ghost"
        >
          Generate more
        </Button>
        <Button
          className={submitAuthFormButton}
          size={'large'}
          disabled={formState.isSubmitting || result.loading}
          type="submit"
          loading={formState.isSubmitting}
        >
          Continue
        </Button>
      </div>
    </form>
  );
};
